/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Forside_Carousel_Go_ToInputs */

const da_forside_carousel_go_to = /** @type {(inputs: Forside_Carousel_Go_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Citat ${i?.number}`)
};

/** @type {(inputs: Forside_Carousel_Go_ToInputs) => LocalizedString} */
const en_forside_carousel_go_to = da_forside_carousel_go_to;

/**

* @param {Forside_Carousel_Go_ToInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_carousel_go_to = /** @type {((inputs: Forside_Carousel_Go_ToInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Carousel_Go_ToInputs, { locale?: "da" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_carousel_go_to(inputs)
	return da_forside_carousel_go_to(inputs)
});